import { render, staticRenderFns } from "./LicenseCategories.vue?vue&type=template&id=65083c51&"
import script from "./LicenseCategories.vue?vue&type=script&lang=js&"
export * from "./LicenseCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports